import fetch from "lib/fetch";
import type { CountryInterface } from "types/reference";

type CountryListResponse = { data: Array<CountryInterface> };

export const getCountriesRequest = (languageCode: string) =>
    fetch.get<CountryListResponse>(`reference/country/${languageCode}`);
